export const rectangleSizeToString = size => {
  if (typeof size !== 'object') {
    return size;
  }

  return `${size.width}x${size.height}`;
};

export const rectangleSizeFromString = size => {
  if (typeof size !== 'string') {
    return size;
  }

  const splitValue = size.split('x');

  return {
    width: parseInt(splitValue[0], 10),
    height: parseInt(splitValue[1], 10),
  };
};
